import { Data } from 'effect';
import type { TabularDataTypeEnum } from 'venn-utils';

export type AxisFormat = Data.TaggedEnum<{
  Percent: {};
  Ratio: {};
}>;
export const AxisFormat = Data.taggedEnum<AxisFormat>();

export const axisFormatFromDataType = (dt?: TabularDataTypeEnum): AxisFormat =>
  dt === 'PERCENTAGE' ? AxisFormat.Percent() : AxisFormat.Ratio();

export const isPercent = AxisFormat.$is('Percent');
